export default __webpack_public_path__ + "static/media/app-store-download.4596411d.svg";